/**
 * Gets the title with page number if set.
 * @param {String} title   The page title.
 * @param {Number} pageNum The current page number.
 * @returns {String}       The page title with page number.
 */
export function getPaginatedTitle(title, pageNum) {
  return (!pageNum || pageNum === 1) ? title : `${title} | page ${pageNum}`;
}
